const items = {
  "setting.display.original.label": "显示原文",
  "setting.display.original.description": "是否显示原文(仅阅读模式)",
  "setting.layout.direction.label": "排版方向",
  "setting.layout.direction.description": "横向或者纵向排版",
  "setting.layout.direction.col.label": "纵向排版",
  "setting.layout.direction.row.label": "横向排版",
  "setting.layout.paragraph.label": "对照方式",
  "setting.layout.paragraph.description": "逐段或逐句对照（仅阅读模式）",
  "setting.layout.paragraph.paragraph.label": "逐段",
  "setting.layout.paragraph.sentence.label": "逐句",
  "setting.pali.script.primary.label": "巴利脚本",
  "setting.pali.script.primary.description": "首要的巴利语脚本",
  "setting.pali.script.secondary.label": "第二巴利脚本",
  "setting.pali.script.secondary.description": "第二个巴利语脚本",
  "setting.pali.script.rome.label": "罗马巴利",
  "setting.pali.script.my.label": "缅文字母",
  "setting.pali.script.si.label": "新哈拉字母",
  "setting.pali.script.thai.label": "泰文字母",
  "setting.pali.script.tai.label": "傣仂文字母",
  "setting.pali.script.none.label": "不显示",
  "setting.search.match.label": "单词匹配",
  "setting.search.match.complete.label": "精确",
  "setting.search.match.case.label": "变格",
  "setting.search.match.similar.label": "形似",
  "setting.search.orderby.label": "排序",
  "setting.search.orderby.rank.label": "相关度",
  "setting.search.orderby.paragraph.label": "段落",
  "setting.dict.lang.label": "字典语言",
  "setting.dict.lang.description": "字典查询结果的语言排序",
  "setting.nissaya.layout.read.label": "阅读排版方式",
  "setting.nissaya.layout.edit.label": "编辑排版方式",
  "setting.nissaya.layout.inline.label": "连续",
  "setting.nissaya.layout.list.label": "列表",
  "setting.wbw.order.label": "显示输入顺序提示",
  "setting.term.first.show.label": "第一个术语",
  "setting.term.first.show.description": "第一个术语的显示方式",
  "term.first.show.meaning_pali_others": "意思巴利及其他意思",
  "term.first.show.meaning_pali": "意思巴利",
  "term.first.show.meaning_others": "意思其他解释",
  "term.first.show.meaning": "仅意思",
  "setting.layout.commentary.label": "注释排版方向",
  "setting.layout.root.fixed.label": "根节点固定显示",
};

export default items;
